import { useEffect } from 'react';
import { createVisualViewportKeyboardTracker } from '../lib/visualViewportKeyboardTracker.js';

/**
 * Mobile Safari / Chrome: keep fixed overlays sized to the visual viewport and
 * scroll focused fields above the software keyboard inside a scrollable container.
 * Do not write CSS vars on every visualViewport scroll - that jitters iOS A2HS.
 */
export function useMobileWebKeyboardViewport(containerRef) {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv || typeof containerRef === 'undefined') return undefined;

    const tracker = createVisualViewportKeyboardTracker({
      getContainer: () => containerRef?.current ?? null,
      visualViewport: vv,
      document,
      requestFrame: (cb) => requestAnimationFrame(cb),
    });

    return () => tracker.dispose();
  }, [containerRef]);
}
